var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container mt-4" },
    [
      _c("h2", { staticClass: "mb-4" }, [_vm._v("Order History")]),
      _c("SelectVenue", {
        ref: "venueDropDown",
        staticClass: "mb-3",
        on: { updateVenue: _vm.updateVenue },
      }),
      _vm.venue_id !== "" && _vm.venue_id !== "0"
        ? _c("SelectBar", {
            ref: "barDropDown",
            staticClass: "mb-3",
            attrs: { venueId: _vm.venue_id, liveOrder: true, optional: true },
            on: { updateBar: _vm.updateBar },
          })
        : _vm._e(),
      _c("div", { staticClass: "mb-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary me-2",
            on: {
              click: function ($event) {
                return _vm.setDateRange("3months")
              },
            },
          },
          [_vm._v("Last 3 Months")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary me-2",
            on: {
              click: function ($event) {
                return _vm.setDateRange("1month")
              },
            },
          },
          [_vm._v("Last Month")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary me-2",
            on: {
              click: function ($event) {
                return _vm.setDateRange("1week")
              },
            },
          },
          [_vm._v("Last Week")]
        ),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary",
            on: {
              click: function ($event) {
                return _vm.setDateRange("24hours")
              },
            },
          },
          [_vm._v("Last 24 Hours")]
        ),
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", [_vm._v("Start Date")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.startDate,
                expression: "startDate",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "date", max: _vm.today, min: _vm.threeMonthsAgo },
            domProps: { value: _vm.startDate },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.startDate = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "col-md-6" }, [
          _c("label", [_vm._v("End Date")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.endDate,
                expression: "endDate",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "date", min: _vm.endDateMin, max: _vm.today },
            domProps: { value: _vm.endDate },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.endDate = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "mb-4" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: { click: _vm.fetchHistoricOrders },
          },
          [_vm._v("Generate")]
        ),
      ]),
      _vm.orders.length > 0
        ? _c("div", { staticClass: "order-summary" }, [
            _c("div", [
              _vm._v("Total Revenue: "),
              _c("strong", [_vm._v(_vm._s(_vm.formattedTotalRevenue))]),
            ]),
            _c("div", [
              _vm._v("Average Order Value: "),
              _c("strong", [_vm._v(_vm._s(_vm.formattedAverageOrderValue))]),
            ]),
            _c("div", [
              _vm._v("Total Orders: "),
              _c("strong", [_vm._v(_vm._s(_vm.filteredOrders.length))]),
            ]),
            _vm.totalRefundedOrders > 0
              ? _c("div", [
                  _vm._v("Total Refunded Orders: "),
                  _c("strong", [_vm._v(_vm._s(_vm.totalRefundedOrders))]),
                ])
              : _vm._e(),
            _vm.totalRefundedOrders > 0
              ? _c("div", [
                  _vm._v("Total Refunded Amount: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.formattedTotalRefundedAmount)),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.orders.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 gap-3",
            },
            [
              _c("div", { staticClass: "flex-fill" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label mb-1",
                    attrs: { for: "orderFilter" },
                  },
                  [_vm._v("Search Orders")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filterText,
                      expression: "filterText",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Search by Order ID" },
                  domProps: { value: _vm.filterText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.filterText = $event.target.value
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "text-end" }, [
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(" Showing "),
                  _c("strong", [_vm._v(_vm._s(_vm.filteredOrders.length))]),
                  _vm._v(" of " + _vm._s(_vm.orders.length) + " orders "),
                ]),
              ]),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.exportToCSV },
                  },
                  [
                    _c("i", { staticClass: "bi bi-download me-1" }),
                    _vm._v(" Export Orders CSV "),
                  ]
                ),
              ]),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.exportItemizedToCSV },
                  },
                  [
                    _c("i", { staticClass: "bi bi-download me-1" }),
                    _vm._v(" Export Items CSV "),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.orders.length > 0
        ? _c(
            "div",
            {
              staticClass: "row header",
              staticStyle: { "background-color": "purple" },
            },
            [
              _c("div", { staticClass: "col-md-1 me-1" }, [
                _vm._v(_vm._s(_vm.getButtonHeader())),
              ]),
              _c("div", { staticClass: "col-md-2 d-none d-md-block" }, [
                _vm._v("Order_ID"),
              ]),
              _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
                _vm._v("Cost"),
              ]),
              _c("div", { staticClass: "col-md-1 d-none d-md-block me-1" }, [
                _vm._v("Completed?"),
              ]),
              _c("div", { staticClass: "col-md-2 d-none d-md-block" }, [
                _vm._v("Time of order"),
              ]),
              _c("div", { staticClass: "col-md-2 d-none d-md-block" }, [
                _vm._v("Time to completion"),
              ]),
              _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
                _vm._v("Stripe?"),
              ]),
              _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
                _vm._v("Refund"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._l(_vm.filteredOrders, function (order, index) {
        return _c("div", { key: index, staticClass: "row py-2" }, [
          _c("div", { staticClass: "col-md-1 me-1" }, [
            _c(
              "button",
              {
                staticClass: "btn text-bg-dark me-2",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.openModal(order)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.getButtonText(order)) + " ")]
            ),
          ]),
          _c("div", { staticClass: "col-md-2 me-1 d-none d-md-block" }, [
            _vm._v(_vm._s(order.readable_ID)),
          ]),
          _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
            _vm._v(_vm._s(_vm.toDollarAmount(order.total_cost))),
          ]),
          _c("div", { staticClass: "col-md-1 d-none d-md-block me-1" }, [
            _vm._v(_vm._s(order.is_complete ? "Yes" : "No")),
          ]),
          _c("div", { staticClass: "col-md-2 d-none d-md-block" }, [
            _vm._v(_vm._s(_vm.formatDate(order.createdAt))),
          ]),
          _c("div", { staticClass: "col-md-2 d-none d-md-block" }, [
            _vm._v(_vm._s(_vm.timeToComplete(order))),
          ]),
          _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
            _vm._v(_vm._s(order.payment_intent_ID ? "Yes" : "No")),
          ]),
          _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
            order.is_complete === true &&
            order.is_cancelled === false &&
            order.payment_intent_ID
              ? _c(
                  "button",
                  {
                    staticClass: "btn btnSubmit d-none d-md-block",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.refundOrder(order)
                      },
                    },
                  },
                  [_vm._v(" Refund ")]
                )
              : order.is_refunded === true
              ? _c("div", [_vm._v(" Yes ")])
              : _c("div", [_vm._v(" N/A ")]),
          ]),
        ])
      }),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          ref: "action",
          attrs: {
            type: "button",
            "data-bs-toggle": "modal",
            "data-bs-target": "#orderListModal",
          },
        },
        [_c("i", { staticClass: "fa-solid fa-plus" })]
      ),
      _c(
        "div",
        {
          ref: "modal",
          staticClass: "modal fade",
          attrs: {
            id: "orderListModal",
            tabindex: "-1",
            "aria-labelledby": "orderList",
            "aria-hidden": "true",
          },
        },
        [
          _c("ViewOrderHistory", {
            attrs: { order: _vm.currentOrder },
            on: { refundOrderModal: _vm.refundOrderModal },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }